import { AxiosResponse } from 'axios';

import API from '../Api';
import { getUserToken, logUserOut } from '../utils/login';
// Types.
import { InvoiceAkamonPaginated, InvoiceLSM } from '../types/billing';

export const fetchInvoices = async (
  method: 'contract' | 'customer',
  dataOwnerCustomerId: number,
  actingCustomerId: number,
  contractCode = 'all',
  ledgerNo: number | 'all' = 'all',
  PageNo = '',
): Promise<InvoiceAkamonPaginated> => {
  const { bearer } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  let queryString = ``;

  if (method === 'customer' && ledgerNo !== 'all') {
    queryString += `ledgerNo=${ledgerNo}`;
  }

  if (PageNo.length > 0) {
    if (queryString.length > 0) {
      queryString += `&`;
    }
    queryString += `pageNo=${PageNo}`;
  }

  const invoiceRequest: AxiosResponse<InvoiceAkamonPaginated> = await API({
    method: 'get',
    url: `/v2/getInvoices/${method}/${dataOwnerCustomerId}/${actingCustomerId}/${contractCode}?${queryString}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return invoiceRequest.data;
};

export const postponeInvoice = async (dataOwnerCustomerId: number, actingCustomerId: number, invoiceNo: string): Promise<{ message: string }> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const postPostponeInvoice: AxiosResponse<{ message: string }> = await API({
    method: 'post',
    url: `/v2/invoicesPostpone/${dataOwnerCustomerId}/${actingCustomerId}/${invoiceNo}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return postPostponeInvoice.data;
};

export const getInvoicesLSM = async (dataOwnerCustomerId: number): Promise<InvoiceLSM[]> => {
  const { bearer, content } = getUserToken();

  if (!bearer || bearer.length === 0) {
    logUserOut();
  }

  const invoicesLSM: AxiosResponse<InvoiceLSM[]> = await API({
    method: 'post',
    url: `/v1/getInvoicesLSM/${dataOwnerCustomerId}`,
    headers: {
      Authorization: `Bearer ${bearer}`,
    },
    data: {
      content: `${content}`,
    },
  }).catch((error) => {
    if (error.response) {
      if (error.response.status === 401) {
        logUserOut();
      }
      return error.response;
    }
  });

  return invoicesLSM.data;
};
